import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/cone/Fun cone orange.png";
import BiscuitImg from "../../../assets/products/cone/Orange-Cone.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 7,
  },
  {
    grams: 12,
  },
];

export default function OrangeConeProduct() {
  return (
    <>
      <Helmet>
        <title>Orange Cone – BearBitz | Premium Biscuits & Treats</title>
        <meta
          name="description"
          content="Explore BearBitz Orange Cone — crisp waffle cones filled with zesty orange cream. View pack sizes and global specifications."
        />
        <meta name="keywords" content="Orange Cone, BearBitz Orange Cone" />
        <link rel="canonical" href="https://www.bearbitz.in/cone/orange-cone" />
        <meta property="og:title" content="Orange Cone – BearBitz" />
        <meta
          property="og:description"
          content="Crisp waffle cone filled with orange-flavored cream by BearBitz, premium and export-ready."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Delight in the crunchy Fun Cone, filled with creamy sweetness that makes every bite a joyful treat. Perfect for kids and adults alike, satisfy your sweet cravings anytime."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FEB088"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFF4EE"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
